import React, { useEffect } from "react";
import OfferBreadShape from "../Assets/img/offer-page/offer-bred-shape.png";
import BannerOfferImg from "../Assets/img/offer-page/banner-offer-img.svg";
import SoftifybdLogo from "../Assets/img/offer-page/softifybd.svg";
import AtovaLogo from "../Assets/img/offer-page/atova.svg";
import VideoBgImg from "../Assets/img/offer-page/video-bg.png";
import VideoPlayerPopup from "../Components/VideoPlayerPopup";
import { Link } from "react-router-dom";

const OfferDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const DetailsCard = [
    {
      id: "card1",
      icon: "fi-rr-time-fast",
      title: "Course duration",
      infotitle: "40 hours",
    },
    {
      id: "card2",
      icon: "fi-rr-book-alt",
      title: "Total classes",
      infotitle: "25 class",
    },
    {
      id: "card3",
      icon: "fi-rr-dollar",
      title: "Course fee",
      infotitle: "Free",
    },
    {
      id: "card4",
      icon: "fi-rr-calendar",
      title: "Course deadline",
      infotitle: "30 Apr, 2022",
    },
  ];

  return (
    <>
      {/* <!-- Breadcrumbs --> */}
      <section
        className="breadcrumbs offer-details-bread"
        style={{ backgroundImage: `url(${OfferBreadShape})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Link to="/offerpage" className="offer-details-two-bred-back">
                <i className="fi-rr-angle-small-left"></i>Back to add-ons
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Breadcrumbs --> */}

      <section className="offer-details-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-12">
                  <div className="offer-details-top-image">
                    <img src={BannerOfferImg} alt="#" />
                    <div className="offer-client-logo">
                      <div className="offer-client-wrapper">
                        <span>Sponsored by:</span>
                        <img src={SoftifybdLogo} alt="#" />
                      </div>
                      <div className="offer-client-wrapper">
                        <span>Training partner:</span>
                        <img src={AtovaLogo} alt="#" />
                      </div>
                    </div>
                  </div>
                  <div className="offer-details-top-content">
                    <h1 className="off-details-top-title">
                      ISP Digital is Offering a Free Course to All New Premium
                      Users
                    </h1>
                    <p className="off-details-cont-para">
                      Natoque viverra sem aliquam tortor. Pharetra vulputate
                      etiam nibh felis, neque. Eget dictum velit est molestie.
                      Sollicitudin tincidunt tincidunt risus dis orci sed in.
                      Dolor, amet vitae morbi ullamcorper nibh leo condimentum.
                    </p>
                    <div className="off-details-cont-btn">
                      <a href="#" className="theme-btn">
                        <i className="fi-rr-user-add"></i>Enroll for free
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {DetailsCard.map((SingleCard) => (
                  <div className="col-lg-3 col-md-4 col-12" key={SingleCard.id}>
                    <div className="offer-details-wrapper">
                      <h4 className="off-details-wrap-title">
                        <i className={SingleCard.icon}></i>
                        {SingleCard.title}
                      </h4>
                      <h6 className="off-details-wrap-info">
                        {SingleCard.infotitle}
                      </h6>
                    </div>
                  </div>
                ))}
              </div>
              <div className="offer-details-more">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12">
                    <div className="offer-course-content">
                      <h3 className="offer-details-more-title">
                        Course Content
                      </h3>
                      <ul className="offer-course-content-list">
                        <li>
                          <i className="fi-rr-cube"></i>Microtik Basic to
                          Advance
                        </li>
                        <li>
                          <i className="fi-rr-cube"></i>FTTx Technology
                        </li>
                        <li>
                          <i className="fi-rr-cube"></i>Billing Management
                        </li>
                        <li>
                          <i className="fi-rr-cube"></i>Support and Client
                          Management
                        </li>
                        <li>
                          <i className="fi-rr-cube"></i>OLT Configuration
                        </li>
                      </ul>
                      <div className="offer-more-btn">
                        <a href="#" className="theme-btn">
                          See more..
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 offset-lg-2 col-md-6 col-12">
                    <div className="course-demo-video">
                      <h3 className="offer-details-more-title">
                        Course Demo Video
                      </h3>
                      <div className="course-demo-main">
                        <img src={VideoBgImg} alt="#" />
                        <div className="video-play">
                          <VideoPlayerPopup />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="course-description-main">
                {/* <!-- Course Description Tab Menu --> */}
                <div className="addons-single__tabs">
                  <ul className="list-group" id="list-tab" role="tablist">
                    <li>
                      <a
                        className="list-group-item active"
                        data-bs-toggle="list"
                        href="#description"
                        role="tab"
                      >
                        Course Description
                      </a>
                    </li>
                    <li>
                      <a
                        className="list-group-item"
                        data-bs-toggle="list"
                        href="#condition"
                        role="tab"
                      >
                        Terms and condition
                      </a>
                    </li>
                    <li>
                      <a
                        className="list-group-item"
                        data-bs-toggle="list"
                        href="#other"
                        role="tab"
                      >
                        Others content
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="nav-tabContent">
                  {/* <!-- Course Tab One --> */}
                  <div
                    className="tab-pane fade show active"
                    id="description"
                    role="tabpanel"
                  >
                    <div className="course-descipsions-cont">
                      <p>
                        Pretium, diam nunc enim purus amet eu imperdiet leo
                        arcu. Mollis magna ultrices vulputate urna, libero,
                        mollis faucibus amet feugiat. Id tortor, cras a ornare
                        donec. Rhoncus duis pellentesque amet euismod.
                        Sollicitudin arcu, ut sed urna amet urna ipsum,
                        vulputate. Porta nunc euismod varius lacus convallis
                        urna. Risus vivamus eget nulla eu. Vitae ac maecenas
                        quis semper turpis nisi.
                      </p>
                      <p>
                        Purus phasellus aliquam et elit elementum integer. Mi,
                        lectus morbi lacus purus quis rhoncus. Arcu mattis diam
                        vitae sit arcu felis, magna aliquet molestie. Tellus et
                        ac non pulvinar iaculis est enim hendrerit justo. Orci,
                        scelerisque felis, diam sociis nisi. Viverra est aenean
                        diam magna eget vulputate mauris. Eget luctus leo,
                        varius orci ullamcorper sed.
                      </p>
                      <p>
                        Commodo adipiscing sed consectetur nunc egestas. Aenean
                        pretium risus non duis sagittis aliquam porttitor. Orci,
                        et ut non, sit nunc cras. Tincidunt sit in venenatis
                        pretium eget congue. Libero in morbi amet, facilisi.
                        Gravida amet nisi, risus egestas eu orci viverra id.
                        Vivamus lacus tellus in quis fringilla aenean fermentum,
                        in facilisis. Ut nullam amet enim interdum at magna. A
                        aliquam faucibus augue imperdiet nulla sit et bibendum.
                        Massa elit quam ut amet netus ut lorem. Potenti
                        tristique turpis vel elit urna a, urna. Dui enim morbi
                        natoque enim consectetur nec id. Consequat tincidunt vel
                        sit duis. Mi donec suscipit purus sed arcu vestibulum
                        venenatis tellus. Molestie eget amet, at a mi ornare
                        fermentum. Viverra sed orci semper aliquam aenean
                        faucibus. Ultrices sed velit purus sollicitudin
                        adipiscing nullam id aliquet lectus. Senectus cras
                        cursus malesuada nisl aliquam. A purus, porttitor
                        sollicitudin eget nullam suspendisse vel. At eleifend
                        arcu semper ultricies. Curabitur adipiscing donec
                        volutpat in diam sapien.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Course Tab Two --> */}
                  <div className="tab-pane fade" id="condition" role="tabpanel">
                    <div className="course-descipsions-cont">
                      <p>
                        Pretium, diam nunc enim purus amet eu imperdiet leo
                        arcu. Mollis magna ultrices vulputate urna, libero,
                        mollis faucibus amet feugiat. Id tortor, cras a ornare
                        donec. Rhoncus duis pellentesque amet euismod.
                        Sollicitudin arcu, ut sed urna amet urna ipsum,
                        vulputate. Porta nunc euismod varius lacus convallis
                        urna. Risus vivamus eget nulla eu. Vitae ac maecenas
                        quis semper turpis nisi.
                      </p>
                      <p>
                        Purus phasellus aliquam et elit elementum integer. Mi,
                        lectus morbi lacus purus quis rhoncus. Arcu mattis diam
                        vitae sit arcu felis, magna aliquet molestie. Tellus et
                        ac non pulvinar iaculis est enim hendrerit justo. Orci,
                        scelerisque felis, diam sociis nisi. Viverra est aenean
                        diam magna eget vulputate mauris. Eget luctus leo,
                        varius orci ullamcorper sed.
                      </p>
                      <p>
                        Commodo adipiscing sed consectetur nunc egestas. Aenean
                        pretium risus non duis sagittis aliquam porttitor. Orci,
                        et ut non, sit nunc cras. Tincidunt sit in venenatis
                        pretium eget congue. Libero in morbi amet, facilisi.
                        Gravida amet nisi, risus egestas eu orci viverra id.
                        Vivamus lacus tellus in quis fringilla aenean fermentum,
                        in facilisis. Ut nullam amet enim interdum at magna. A
                        aliquam faucibus augue imperdiet nulla sit et bibendum.
                        Massa elit quam ut amet netus ut lorem. Potenti
                        tristique turpis vel elit urna a, urna. Dui enim morbi
                        natoque enim consectetur nec id. Consequat tincidunt vel
                        sit duis. Mi donec suscipit purus sed arcu vestibulum
                        venenatis tellus. Molestie eget amet, at a mi ornare
                        fermentum. Viverra sed orci semper aliquam aenean
                        faucibus. Ultrices sed velit purus sollicitudin
                        adipiscing nullam id aliquet lectus. Senectus cras
                        cursus malesuada nisl aliquam. A purus, porttitor
                        sollicitudin eget nullam suspendisse vel. At eleifend
                        arcu semper ultricies. Curabitur adipiscing donec
                        volutpat in diam sapien.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Course Tab Three --> */}
                  <div className="tab-pane fade" id="other" role="tabpanel">
                    <div className="course-descipsions-cont">
                      <p>
                        Pretium, diam nunc enim purus amet eu imperdiet leo
                        arcu. Mollis magna ultrices vulputate urna, libero,
                        mollis faucibus amet feugiat. Id tortor, cras a ornare
                        donec. Rhoncus duis pellentesque amet euismod.
                        Sollicitudin arcu, ut sed urna amet urna ipsum,
                        vulputate. Porta nunc euismod varius lacus convallis
                        urna. Risus vivamus eget nulla eu. Vitae ac maecenas
                        quis semper turpis nisi.
                      </p>
                      <p>
                        Purus phasellus aliquam et elit elementum integer. Mi,
                        lectus morbi lacus purus quis rhoncus. Arcu mattis diam
                        vitae sit arcu felis, magna aliquet molestie. Tellus et
                        ac non pulvinar iaculis est enim hendrerit justo. Orci,
                        scelerisque felis, diam sociis nisi. Viverra est aenean
                        diam magna eget vulputate mauris. Eget luctus leo,
                        varius orci ullamcorper sed.
                      </p>
                      <p>
                        Commodo adipiscing sed consectetur nunc egestas. Aenean
                        pretium risus non duis sagittis aliquam porttitor. Orci,
                        et ut non, sit nunc cras. Tincidunt sit in venenatis
                        pretium eget congue. Libero in morbi amet, facilisi.
                        Gravida amet nisi, risus egestas eu orci viverra id.
                        Vivamus lacus tellus in quis fringilla aenean fermentum,
                        in facilisis. Ut nullam amet enim interdum at magna. A
                        aliquam faucibus augue imperdiet nulla sit et bibendum.
                        Massa elit quam ut amet netus ut lorem. Potenti
                        tristique turpis vel elit urna a, urna. Dui enim morbi
                        natoque enim consectetur nec id. Consequat tincidunt vel
                        sit duis. Mi donec suscipit purus sed arcu vestibulum
                        venenatis tellus. Molestie eget amet, at a mi ornare
                        fermentum. Viverra sed orci semper aliquam aenean
                        faucibus. Ultrices sed velit purus sollicitudin
                        adipiscing nullam id aliquet lectus. Senectus cras
                        cursus malesuada nisl aliquam. A purus, porttitor
                        sollicitudin eget nullam suspendisse vel. At eleifend
                        arcu semper ultricies. Curabitur adipiscing donec
                        volutpat in diam sapien.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OfferDetails;
